// Endpoints where the Blizzard SDK uploads event paylods

// Unauthenticated routes - default for the SDK.
export const defaultBaseUrlStaging =
  'https://staging-us-central1-gcp.api.snapchat.com/web-analytics/web';
export const defaultBaseUrl = 'https://us-central1-gcp.api.snapchat.com/web-analytics/web';
// export const defaultBaseUrl = "http://localhost:8010/proxy/web-analytics/web";

export const defaultSpectrumBaseUrl = 'https://gcp.api.snapchat.com/streaming-collector/collect';

// HTTP
export const contentTypeJson = 'application/json; charset=UTF-8';
export const contentTypeProto = 'application/x-protobuf';
export const statusesPossibleAuthFailure = [400, 401, 403]; // collector sometimes returns 400 for some reason
